export default __webpack_public_path__ + "static/LAPIERRE_MAIN_16x9_Nico_Vouilloz-f5dcb0d3ad429cba2c9af8eb35a895da.mp4";